import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import type { Observable } from 'rxjs'

import * as environment from '@app/environment'

export function apiUrlInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (request.url.startsWith('http')) {
    return next(request)
  }

  const url = `${environment.apiHost}${request.url.startsWith('/') ? '' : '/'}${request.url}`
  return next(request.clone({ url }))
}
